var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "./Tools"], function (require, exports, Tools_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createButton = void 0;
    const createButton = (toolDef, markupsGuiExtension, coreExtension) => {
        var _a;
        let button;
        if ((_a = toolDef.childTools) === null || _a === void 0 ? void 0 : _a.length) {
            button = new Autodesk.Viewing.UI.ComboButton(`markups-${toolDef.code}`);
            toolDef.childTools.forEach((childToolDef) => {
                // @ts-ignore
                button.addControl(exports.createButton(childToolDef, markupsGuiExtension, coreExtension));
            });
        }
        else {
            button = new Autodesk.Viewing.UI.Button(`markups-${toolDef.code}`);
        }
        button.setToolTip(toolDef.name);
        button.addClass(`markups-btn`);
        button.addClass(`markups-btn-${toolDef.code}`);
        if (toolDef.icon) {
            button.setIcon(`icon-markups-${toolDef.code}`);
            // @ts-ignore
            button.icon.innerText = toolDef.icon;
        }
        else {
            button.addClass('text-btn');
            // @ts-ignore
            button.icon.innerText = toolDef.name;
        }
        if (toolDef.toolFactory) {
            button.onClick = () => __awaiter(void 0, void 0, void 0, function* () {
                markupsGuiExtension.toggleTools([`markups-${toolDef.code}`]);
                yield markupsGuiExtension.activateTool(toolDef);
                coreExtension.changeEditMode(yield Tools_1.getTool(coreExtension, toolDef));
            });
        }
        else if (toolDef.action) {
            button.onClick = () => {
                var _a;
                (_a = toolDef.action) === null || _a === void 0 ? void 0 : _a.call(toolDef);
            };
        }
        return button;
    };
    exports.createButton = createButton;
});
//# sourceMappingURL=Button.js.map